"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchHelper = void 0;
var Console_helper_1 = require("./Console.helper");
exports.FetchHelper = {
    mock: function (requests) {
        global.fetch = function (url, options) {
            var currentRequest = requests.find(function (request) {
                return request.condition(url);
            });
            return Promise.resolve({
                headers: null,
                redirected: false,
                status: 200,
                statusText: "ok",
                type: null,
                ok: true,
                url: null,
                clone: null,
                body: null,
                bodyUsed: null,
                arrayBuffer: null,
                blob: null,
                formData: null,
                text: null,
                json: function () {
                    var response = !!currentRequest && typeof currentRequest.json === "function"
                        ? currentRequest.json(url, options)
                        : {};
                    Console_helper_1.ConsoleHelper.log("Request Mocked: ", url, response);
                    return response;
                },
            });
        };
    },
};
